import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import MuiTableCell from '@material-ui/core/TableCell';
import { combineClasses, styled, useThemeProps, } from '../../foundation';
import { RcSelect } from '../Forms/Select';
import { RcToolbar } from '../Toolbar';
import { RcTypography } from '../Typography';
import { RcTablePaginationActions, TablePaginationMenuItem, TablePaginationRoot, TablePaginationStyle, } from './styles';
import { defaultLabelDisplayedRows, defaultLabelOfPage, RcTablePaginationClasses, } from './utils';
var _RcTablePagination = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTablePagination' });
    var classesProp = props.classes, _a = props.type, type = _a === void 0 ? 'displayedRows' : _a, _b = props.ActionsComponent, ActionsComponent = _b === void 0 ? RcTablePaginationActions : _b, className = props.className, colSpanProp = props.colSpan, _c = props.component, component = _c === void 0 ? MuiTableCell : _c, count = props.count, _d = props.labelDisplayedRows, labelDisplayedRows = _d === void 0 ? defaultLabelDisplayedRows : _d, _e = props.labelOfPage, labelOfPage = _e === void 0 ? defaultLabelOfPage : _e, _f = props.labelRowsPerPage, labelRowsPerPage = _f === void 0 ? 'Rows per page:' : _f, onPageChange = props.onPageChange, onRowsPerPageChange = props.onRowsPerPageChange, _g = props.rowsPerPageOptions, rowsPerPageOptions = _g === void 0 ? [10, 25, 50, 100] : _g, _h = props.SelectProps, SelectProps = _h === void 0 ? {} : _h, page = props.page, rowsPerPage = props.rowsPerPage, backIconButtonProps = props.backIconButtonProps, nextIconButtonProps = props.nextIconButtonProps, 
    // getItemAriaLabel = defaultGetAriaLabel,
    // showFirstButton = false,
    // showLastButton = false,
    rest = __rest(props, ["classes", "type", "ActionsComponent", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelOfPage", "labelRowsPerPage", "onPageChange", "onRowsPerPageChange", "rowsPerPageOptions", "SelectProps", "page", "rowsPerPage", "backIconButtonProps", "nextIconButtonProps"]);
    var MenuItemComponent = SelectProps.native
        ? 'option'
        : TablePaginationMenuItem;
    var totalPage = Math.ceil(count / rowsPerPage);
    var isPageSelection = type === 'pageSelection';
    var classes = useMemo(function () { return combineClasses(RcTablePaginationClasses, classesProp); }, [classesProp]);
    // const selectId = useId(SelectProps.id);
    // const labelId = useId(SelectProps.labelId);
    var colSpan;
    if (component === MuiTableCell || component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
    }
    var getLabelDisplayedRowsTo = function () {
        if (count === -1)
            return (page + 1) * rowsPerPage;
        return rowsPerPage === -1
            ? count
            : Math.min(count, (page + 1) * rowsPerPage);
    };
    var menuItems = useMemo(function () {
        var menus = [];
        if (!isPageSelection)
            return menus;
        var _loop_1 = function (i) {
            menus.push(React.createElement(MenuItemComponent, { value: i, selected: i === page, key: i, className: classes.menuItem, onClick: function (e) {
                    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(e, i);
                } }, i + 1));
        };
        for (var i = 0; i < totalPage; i++) {
            _loop_1(i);
        }
        return menus;
    }, [
        MenuItemComponent,
        classes,
        isPageSelection,
        onPageChange,
        page,
        totalPage,
    ]);
    return (React.createElement(TablePaginationRoot, __assign({ colSpan: colSpan, ref: ref, as: component, className: clsx(classes.root, className) }, rest),
        React.createElement(RcToolbar, { className: classes.toolbar },
            React.createElement("div", { className: classes.spacer }),
            rowsPerPageOptions.length > 1 && (React.createElement(RcTypography, { color: "inherit", variant: "body1", className: classes.caption }, labelRowsPerPage)),
            rowsPerPageOptions.length > 1 && (React.createElement(RcSelect, __assign({ className: classes.selectRoot, InputProps: { disableUnderline: true }, value: rowsPerPage, onChange: onRowsPerPageChange }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
                var value = rowsPerPageOption.value
                    ? rowsPerPageOption.value
                    : rowsPerPageOption;
                var label = rowsPerPageOption.label
                    ? rowsPerPageOption.label
                    : rowsPerPageOption;
                return (React.createElement(MenuItemComponent, { className: classes.menuItem, key: value, value: value }, label));
            }))),
            isPageSelection ? (React.createElement(React.Fragment, null,
                React.createElement(RcSelect, { value: page, InputProps: { disableUnderline: true }, renderValue: function (p) { return p + 1; }, virtualize: true }, menuItems),
                React.createElement("p", { className: classes.caption }, labelOfPage({ totalPage: totalPage })))) : (React.createElement("p", { className: classes.caption }, labelDisplayedRows({
                from: count === 0 ? 0 : page * rowsPerPage + 1,
                to: getLabelDisplayedRowsTo(),
                count: count === -1 ? -1 : count,
                page: page,
            }))),
            React.createElement(ActionsComponent, { className: classes.actions, backIconButtonProps: backIconButtonProps, count: count, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage }))));
});
var RcTablePagination = styled(_RcTablePagination)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TablePaginationStyle);
RcTablePagination.displayName = 'RcTablePagination';
export { RcTablePagination };
var templateObject_1;
